import { render } from "./dictData.vue?vue&type=template&id=2f5a3216"
import script from "./dictData.vue?vue&type=script&lang=js"
export * from "./dictData.vue?vue&type=script&lang=js"

import exportComponent from "D:\\workspace\\zh-frontend\\microfront-main\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__